<template>
    <div id="list-reporting-column-preset"
         class="modal inmodal fade"
         role="dialog"
         aria-hidden="true"
         data-backdrop="static"
         tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header modal-header-dialog-painting text-left">
                    <h2 class="modal-title" v-if="mode === 'add'">{{ t_new_column_preset_title }}</h2>
                    <h2 class="modal-title" v-if="mode === 'edit'">{{ t_edit_column_preset_title }}</h2>
                </div>
                <div class="modal-body">
                    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger modal-errors">
                        {{ t_save_error }}
                        <ul>
                            <li v-for="error in errors">
                                {{error}}
                            </li>
                        </ul>
                    </div>
                    <form v-on:submit.prevent class="list-reporting-column-preset" role="form">
                        <div class="row modal-fixed-row">
                            <div class="col-md-12">
                                <div v-bind:class="[(typeof errors.name !== 'undefined' ? 'has-error':''),'form-group']">
                                    <label>{{ t_name }}:</label>
                                    <input type="text" ref="name" class="form-control" v-model="name">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="scrollBox" :style="'max-height: ' + maxInnerHeight + 'px;'">
                                <draggable v-model="fields" @start="drag=true" @end="drag=false"
                                           handle=".handle">
                                    <div class="col-md-12 no-padding m-b-sm border-bottom" v-for="element in fields">
                                        <div class="i-checks">
                                            <label>
                                                <i class="fa-regular fa-arrows-up-down handle m-r-md"></i>
                                                <i v-bind:class="[element.active === 1 ? 'fa-square-check' : 'fa-square' ,'fa-regular m-r-sm']"
                                                   @click.stop.prevent="toggle(element.id)"></i><span>{{ element.name }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <v-btn type="button" class="btn btn-secondary pull-left" @click.stop.prevent="remove"
                            v-if="mode === 'edit'">
                        <i v-if="deleting === true" class="fa-regular fa-spinner fa-spin-pulse m-r-xs"></i>
                        {{ t_delete }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-primary submit" @click.stop.prevent="update"
                            v-if="mode === 'add'">
                        <i v-if="saving === true" class="fa-regular fa-spinner fa-spin-pulse m-r-xs"></i>
                        {{ t_add }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-primary submit" @click.stop.prevent="update"
                            v-if="mode === 'edit'">
                        <i v-if="saving === true" class="fa-regular fa-spinner fa-spin-pulse m-r-xs"></i>
                        {{ t_save }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-secondary" data-dismiss="modal">{{ t_cancel }}</v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../common/modal-mixin"
    import draggable from 'vuedraggable';
    import toaster from "../common/toaster";

    export default {
        mixins: [
            modalMixin
        ],
        components: {
            draggable
        },
        data: function () {
            return {
                t_close: Lang.langGet("Close"),
                t_new_column_preset_title: Lang.langGet("New Column Preset"),
                t_cancel: Lang.langGet("Cancel"),
                t_save: Lang.langGet("Save"),
                t_add: Lang.langGet("Add"),
                t_delete: Lang.langGet("Delete"),
                t_load_error: Lang.langGet("Failed to load Column Preset data."),
                t_save_success: Lang.langGet("Column Preset successfully saved."),
                t_save_error: Lang.langGet("Failed to save Column Preset."),
                t_delete_success: Lang.langGet("Column Preset successfully deleted."),
                t_delete_error: Lang.langGet("Failed to delete Column Preset."),
                t_name: Lang.langGet("Column Preset Name"),
                mode: 'add',
                name: '',
                fields: [],
                preset_id: -1,
                errors: {},
                deleting: false,
                saving: false,
                modalName: 'list-reporting-column-preset'
            }
        },
        computed: {
            t_edit_column_preset_title: function () {
                return Lang.langGet("Edit Column Preset \":name\"", {name: this.name});
            }
        },
        methods: {
            update: function () {
                if(this.saving === true) {
                    return;
                }

                this.saving = true;

                axios.post('/system/reporting/list-update-column', {
                    fields: this.fields,
                    preset_id: this.preset_id,
                    name: this.name,
                    project_id: Laravel.activeProject
                }).then(() => {
                    this.saving = false;
                    toaster.success(this.t_save_success);
                    EaseEventBus.fire('hideModal', this.modalName);
                    EaseEventBus.fire('updateExistingColumnPresets');
                    //workaround to not start a rewrite in the old codebase
                    EaseEventBus.listen('loadedReportColumnPreset', () => {
                        EaseEventBus.fire('setNewReportColumnPresetAsCurrent', {name: this.name});
                    })
                }).catch((error) => {
                    this.saving = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    } else if (error.response.status === 422) {
                        let tmpErrors = {};

                        for (let key in error.response.data.errors) {
                            tmpErrors[key] = error.response.data.errors[key][0];
                        }
                        this.errors = _.extend({}, this.errors, tmpErrors);
                    } else {
                        toaster.error(this.t_save_error);
                    }
                });
            },
            remove: function () {
                if(this.deleting === true) {
                    return;
                }

                this.deleting = true;

                axios.post('/system/reporting/list-delete-column', {
                    project_id: Laravel.activeProject,
                    preset_id: this.preset_id
                }).then(() => {
                    this.deleting = false;
                    EaseEventBus.fire('updateExistingColumnPresets');
                    EaseEventBus.fire('hideModal', this.modalName);
                    EaseEventBus.fire('setNewReportColumnPresetAsCurrent', {name: 'Select a Column Preset...'});
                    toaster.success(this.t_delete_success);
                }).catch((error) => {
                    this.deleting = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_delete_error);
                });
            },
            load: function () {
                axios.post('/system/reporting/list-data-column', {
                    project_id: Laravel.activeProject,
                    preset_id: this.preset_id
                }).then((response) => {
                    this.fields = response.data.data;
                    EaseEventBus.fire('showModal', this.modalName);
                    this.$nextTick(function () {
                        this.$refs.name.focus();
                    });
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_error);
                });
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
            },
            toggle: function (id) {
                this.fields.forEach((element) => {
                    if (element['id'] === id) {
                        if (element['active'] === 0) {
                            element['active'] = 1;
                        } else {
                            element['active'] = 0;
                        }
                    }
                });
            }
        },
        mounted() {
            EaseEventBus.listen('showEditDeleteColumnPresetModal', (data) => {
                this.reset();
                this.name = data.name;
                this.preset_id = data.id;
                this.mode = 'edit';
                this.load();
            });

            EaseEventBus.listen('showNewColumnPresetModal', () => {
                this.reset();
                this.mode = 'add';
                this.load();
            });
        }
    }
</script>
